@if (false) {
<!-- <div class="modal-body  col-sm-12 form-group">
    <form #AddLibraryEvent="ngForm" [formGroup]="addLibraryEvent" (ngSubmit)="onLibrarySubmit(AddLibraryEvent.value);">

        <div class="col-sm-12" style="padding:4px">
            <div class="col-sm-2 height-34"><a href="{{RouteGMLibCategory}}" target="_blank">File Category</a></div>
            <div class="col-sm-4">
                <ng-select [items]="LibraryCategoryList" bindLabel="MainDescr" bindValue="hdID"
                    formControlName="LibCategory" (change)="onCategorySelect($event)" placeholder="Not Selected">
                </ng-select>
            </div>
            <div class="col-sm-2 height-34"><a href="{{RouteGMLibSubCategory}}" target="_blank">File Sub Category</a>
            </div>
            <div class="col-sm-4">
                <ng-select [items]="LibrarySubCategoryList" bindLabel="MainDescr" bindValue="hdID"
                    formControlName="LibSubCategory" placeholder="Not Selected">
                </ng-select>
            </div>

        </div>
        <div class="col-sm-12">
            <hr>
        </div>
        <div class="col-sm-12" style="padding:4px">
            <div class="col-sm-2 height-34"><a routerLink="{{RouteCompany}}" target="_blank">Company</a></div>
            <div class="col-sm-4">
                <ng-select [items]="Company" bindLabel="Name" bindValue="ID" formControlName="Company"
                    placeholder="Not Selected">
                </ng-select>
            </div>
            <div class="col-sm-2 height-34"><a routerLink="{{RouteGMDepartment}}" target="_blank">Department</a></div>
            <div class="col-sm-4">
                <ng-select [items]="Department" bindLabel="MainDescr" bindValue="hdID" formControlName="Department"
                    placeholder="Not Selected" appendTo="body" dropdownPosition="bottom">
                </ng-select>
            </div>
        </div>

        <div class="col-sm-12">
            <hr>
        </div>

        <div class="col-sm-12" style="padding:4px">

            <div class="col-sm-2 height-34">File No / Ref</div>
            <div class="col-sm-4"><input class="form-control" formControlName="fileRef"
                    placeholder="Enter File Ref or File No" type="text">
            </div>
            <div class="col-sm-2 height-34">File Description</div>
            <div class="col-sm-4"><textarea class="form-control" formControlName="fileDescription" rows="2"
                    placeholder="File Description"></textarea></div>


        </div>
        <div class="col-sm-12">
            <hr>

        </div>


        <div class="col-sm-12" style="padding:4px">
            <div class="col-sm-2 height-34">File Privacy</div>
            <div class="col-sm-4">
                <label class="radio-inline"><input type="radio" formControlName="IsPublic" value="1">Public</label>
                <label class="radio-inline"><input type="radio" formControlName="IsPublic" value="0">Private</label>
            </div>
            <div class="col-sm-2 height-34"><a href="{{RouteUserMaster}}" target="_blank">Share With</a></div>
            <div class="col-sm-4">
                <ng-select [items]="UsersList" [clearable]="false" [multiple]="true" formControlName="ShareWithUser"
                    bindLabel="name" [selectableGroup]="true" [closeOnSelect]="true" bindValue="id1"
                    [(ngModel)]="selectedUsers">
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        {{item.name}}
                    </ng-template>
                </ng-select>
            </div>

        </div>
        <div class="col-sm-12">
            <hr>
        </div>
        <div class="col-sm-12" style="padding:4px">
            <div class="col-sm-2 height-34"><a href="{{RouteGMProduct}}" target="_blank">Product</a></div>
            <div class="col-sm-4">
                <ng-select [items]="ProductHelpList" bindLabel="MainDescr" bindValue="hdID"
                    formControlName="HelpProduct" placeholder="Not Selected">
                </ng-select>

            </div>
            <div class="col-sm-2 height-34">Upload File*</div>
            <div class="col-sm-4" style="padding-top:5px;"><input type='file' formControlName="browseFiles"
                    (change)="onSelectFile($event)">
                <table *ngFor="let lbD of libraryDetail; let i=index ">
                    <tr *ngFor="let lbDFile of lbD.attachment; let i=index">
                        <td><a href={{DownloadURL}}{{lbDFile.DownloadPath}}>{{lbDFile.DisplayName}}</a></td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="col-sm-12">
            <hr>
        </div>

        <div class="col-sm-4">&nbsp;</div>
        <div class="col-sm-5"><br><br>
            <div class="form-group col-sm-4"
                *ngIf="this.RightsID.includes('202028001') || this.RightsID.includes('202028021') ; then AddLibraryLink else AddLibrary">
            </div>
            <ng-template #AddLibraryLink>
                <input class="btn btn-primary col-sm-6" type="submit" value="{{ButtonCaption}}">
            </ng-template>
            <ng-template #AddLibrary>
                &nbsp;
            </ng-template>
        </div>
        <div class="col-sm-3"><label style="Display:none;" *ngFor='let urldata of fileurls'>{{urldata}}</label></div>
        <div class="form-group mt-2" style="display:none;">
            <div class="form-check">
                <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true
                    [(ngModel)]="options.autoClose">
                <label for="autoClose">Auto close alert after three seconds</label>
            </div>

        </div>
        <div class="jumbotron p-4">
            <div class="container text-center col-sm-3 alertCss">
                <app-alert></app-alert>
                <router-outlet></router-outlet>
            </div>
        </div>
    </form>
</div> -->
} @else {
<div class="modal-body">

    <form [formGroup]="addLibraryEvent" (ngSubmit)="onLibrarySubmit(addLibraryEvent.value)">
        <div class="card border-0 rounded-4">
            <div class="card-body">

                <!-- ================= CATEGORY ================= -->
                <div class="row g-3">

                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <label>
                                <a [href]="RouteGMLibCategory" target="_blank">File Category <span class="text-danger">*</span> </a>
                            </label>
                            <ng-select [items]="LibraryCategoryList" bindLabel="MainDescr" bindValue="hdID"
                                formControlName="LibCategory" (change)="onCategorySelect($event)"
                                placeholder="Select category">
                            </ng-select>
                            @if (f.LibCategory.touched && f.LibCategory.invalid) {
                                @if (f.LibCategory.errors.required) {
                                    <div class="text-danger">
                                        <small>Category is required.</small>
                                    </div>
                                }
                            }
                        </div>
                    </div>

                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <label>
                                <a [href]="RouteGMLibSubCategory" target="_blank">File Sub Category <span class="text-danger">*</span>  </a>
                            </label>
                            <ng-select [items]="LibrarySubCategoryList" bindLabel="MainDescr" bindValue="hdID"
                                formControlName="LibSubCategory" placeholder="Select sub category">
                            </ng-select>
                            @if (f.LibSubCategory.touched && f.LibSubCategory.invalid) {
                                @if (f.LibSubCategory.errors.required) {
                                    <div class="text-danger">
                                        <small>Sub Category is required.</small>
                                    </div>
                                }
                            }
                        </div>
                    </div>

                    <!-- ================= COMPANY / DEPARTMENT ================= -->

                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <label>
                                <a [routerLink]="RouteCompany" target="_blank">Company <span class="text-danger">*</span></a>
                            </label>
                            <ng-select [items]="Company" bindLabel="Name" bindValue="ID" formControlName="Company"
                                placeholder="Select company">
                            </ng-select>
                            @if (f.Company.touched && f.Company.invalid) {
                                @if (f.Company.errors.required) {
                                    <div class="text-danger">
                                        <small>Company is required.</small>
                                    </div>
                                }
                            }
                        </div>
                    </div>

                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <label>
                                <a [routerLink]="RouteGMDepartment" target="_blank">Department <span class="text-danger">*</span></a>
                            </label>
                            <ng-select [items]="Department" bindLabel="MainDescr" bindValue="hdID"
                                formControlName="Department" placeholder="Select department" appendTo="body"
                                dropdownPosition="bottom">
                            </ng-select>
                            @if (f.Department.touched && f.Department.invalid) {
                                @if (f.Department.errors.required) {
                                    <div class="text-danger">
                                        <small>Department is required.</small>
                                    </div>
                                }
                            }
                        </div>
                    </div>

                    <!-- ================= FILE INFO ================= -->

                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <label>File No / Ref</label>
                            <input class="form-control" formControlName="fileRef"
                                placeholder="Enter File Ref or File No" type="text" />
                        </div>
                    </div>

                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <label>File Description</label>
                            <textarea class="form-control" formControlName="fileDescription" rows="2"
                                placeholder="File Description">
                    </textarea>
                        </div>
                    </div>

                    <!-- ================= PRIVACY & SHARE ================= -->

                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <label>File Privacy</label><br />
                            <label class="me-3">
                                <input type="radio" formControlName="IsPublic" value="1" /> Public
                            </label>
                            <label>
                                <input type="radio" formControlName="IsPublic" value="0" /> Private
                            </label>
                        </div>
                    </div>

                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <label>
                                <a [href]="RouteUserMaster" target="_blank">Share With</a>
                            </label>
                            <ng-select [items]="UsersList" [multiple]="true" [clearable]="false"
                                formControlName="ShareWithUser" bindLabel="name" bindValue="id1">
                                <ng-template ng-option-tmp let-item="item">
                                    {{ item.name }}
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>

                    <!-- ================= PRODUCT / UPLOAD ================= -->

                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <label>
                                <a [href]="RouteGMProduct" target="_blank">Product</a>
                            </label>
                            <ng-select [items]="ProductHelpList" bindLabel="MainDescr" bindValue="hdID"
                                formControlName="HelpProduct" placeholder="Select product">
                            </ng-select>
                        </div>
                    </div>

                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <label>Upload File <span class="text-danger">*</span></label>
                            <input type="file" formControlName="browseFiles" (change)="onSelectFile($event)" />
                            @if (f.browseFiles.touched && f.browseFiles.invalid) {
                                @if (f.browseFiles.errors.required) {
                                    <div class="text-danger">
                                        <small>File is required.</small>
                                    </div>
                                }
                            }
                            @for (lbD of libraryDetail; track $index) {
                            @for (lbDFile of lbD.attachment; track $index) {
                            <div class="mt-1">
                                <a [href]="DownloadURL + lbDFile.DownloadPath">
                                    {{ lbDFile.DisplayName }}
                                </a>
                            </div>
                            }
                            }
                        </div>
                    </div>

                </div>


            </div>
        </div>
        <!-- ================= SUBMIT ================= -->
        <div class="d-flex justify-content-center mt-3">
            @if (
            RightsID.includes('202028001') ||
            RightsID.includes('202028021')
            ) {
            <button class="btn btn-primary submit-btn small " type="submit">
                {{ ButtonCaption }}
            </button>   
            }
        </div>
    </form>
</div>
}